import React, {useEffect, useRef, useState} from 'react';
import {
    Box,
    Button,
    Checkbox,
    Divider,
    Fade,
    FormControl,
    Menu,
    MenuItem,
    Radio,
    Select,
    Slider,
    Typography
} from '@mui/material';
import {API, TOOLTIPS} from '../../utils/Constants';
import {dateToFormatDateServer, dateToFormatUi} from '../../utils/Utils';
import DatePicker from 'react-datepicker';
import BackspaceIcon from '@mui/icons-material/Backspace';
import {fetchCategories} from '../../api/api';
import RequestSvc from '../../services/RequestSvc';

export default function FiltersUserVaultComponent({
                                                      setQueryStringObject,
                                                      isLoadingData
                                                  }) {

    /* INIT VARS - HOOKS    */

    /**
     * Valores en el campo de búsqueda de texto
     */
    const [searchTerms, setSearchTerms] = useState('');
    /**
     * Contiene el valor seleccionado o configurado en el slider
     */
    const [valueSlider, setValueSlider] = useState(0);
    /**
     * Configura el rango del slider
     * @type {[{value: number},{value: number}]}
     */
    const sliderMark = [{value: 0}, {value: 40}]
    /**
     * Contiene el estado seleccionado para la búsqueda del anuncio
     */
    let [adsStatus, setAdsStatus] = useState('');
    /**
     * Contiene los estados de los anuncios organizados por la descripción del estado.
     */
    let [statusIndexedAds] = useState([])
    /**
     * Contiene el codigo del estatus selecccionado
     */
    let [adsStatusCodeSelected, setAdsStatusCodeSelected] = useState('')
    /**
     * Contiene la descripción y códigos de estados de los anuncios disponibles para filtrar.
     * @type {Readonly<{INACTIVOS: string, ACTIVOS: string, TODOS: string, ACTIVOS_E_INACTIVOS: string, ANUNCIOS_SEGUIDOS: string}>}
     */
    const availableStatus = [
        {name: 'Activos', code: 'ACTIVE'},
        {name: 'Inactivos', code: 'INACTIVE'},
        {name: 'Activos e inactivos', code: 'ANY'},
        {name: 'Anuncios seguidos', code: 'FOLLOW'},
        {name: 'Todos', code: 'ALL'}
    ]
    /**
     * Contiene los datos del combo de cta
     */
    let [arrayCta, setArrayCta] = useState([]);
    /**
     * Contitne los datos del cta indexados por la descripcion del cta
     */
    let [dataComboCtaIndexed, setDataComboCtaIndexed] = useState([]);
    /**
     * Variable necesaria para la configuración del menú que muestra el calendario.
     */
    const [anchorElCalendar, setAnchorElCalendar] = useState(null);
    /**
     * Texto usado como pleceholder del calendario.
     * @type {string}
     */
    const labelCalendar = 'Seleccionar rango de fechas';
    /**
     * Bandera que indica si se está mostrando el calendario.
     * @type {boolean}
     */
    const openCalendar = Boolean(anchorElCalendar);
    /**
     * Contiene el texto actual o mostrado en el botón o ítem del calendario.
     */
    let [showLabelCalendar, setShowLabelCalendar] = useState(labelCalendar);
    /**
     * Contiene el valor de la fecha inicial seleccionada en el calendario.
     */
    const [startDate, setStartDateIn] = useState('');
    /**
     * Contiene el valor de la fecha final seleccionada en el calendario.
     */
    const [endDate, setEndDateIn] = useState(null);
    /**
     * Las variables ref se están usando como referencias para saber que div de la grilla de fechas predeterminadas fue seleccionada.
     * Esta implementación se cambiará posteriormente, ya que la implementación original sí necesitaba hacer uso de useRef.
     * Esta implementación no la necesita
     */
    const ref1d = useRef();
    const ref7d = useRef();
    const ref15d = useRef();
    const ref30d = useRef();
    const ref45d = useRef();
    const ref3m = useRef();
    const ref6m = useRef();
    const ref12m = useRef();
    const ref18m = useRef();
    const ref24m = useRef();
    /**
     * Almacena la referencia del item seleccionado en la grilla de fechas predeterminadas.
     */
    const [refSelected, setRefSelected] = useState()
    /**
     *
     * @type {Date}
     */
    let enableDateRange = new Date();
    /**
     * Clase que se asigna al item de la grilla de fechas predeterminadas, cuando no ha sido seleccionada.
     * @type {string}
     */
    let unSelected = 'filters-component-calendar-cell-custom-values';
    /**
     * Clase que se asigna al item de la grilla de fechas predeterminadas, cuando ha sido seleccionada.
     * @type {string}
     */
    let selected = 'filters-component-calendar-cell-custom-values-selected';
    /**
     * Contiene la informacion de las categorias del usuario.
     */
    const [categories, setCategories] = useState([
        {'Category_Name': 'Todos', 'FK_Category_Code': 'All'}
    ])
    const [indexedCategories, setIndexedCategories] = useState([]);
    /**
     * Contiene el codigo de la categoria que se ha seleccionado
     */
    const [categoryCodeSelected, setCategoryCodeSelected] = useState(null);
    /**
     * Contiene la descripcion o nombre de la categoria seleccionada.
     */
    const [categoryNameSelected, setCategoryNameSelected] = useState('');
    /**
     * Objeto de la clase que se usa para hacer request
     * @type {RequestSvc}
     */
    const requestSvc = new RequestSvc();
    /**
     * Contiene los datos para el combo o menú de cta.
     */
    let [dataComboCta, setDataComboCta] = useState([])
    /**
     * Objeto por defecto para realizar los request
     * @type {{page: number}}
     */
    let defaultParamsRequest = {page: 0}
    /**
     * Objeto que toma el valores del ultimo request realizado, para evitar que se repita el mismo request seguido del anterior.
     * @type {{}}
     */
    let defaultOldParamsRequest = {}
    /**
     * crear el obejto que se usara como queryString para hacer la peticion al servidor.
     */
    let [paramsRequest, setParamsRequest] = useState(defaultParamsRequest);
    /**
     * Contiene los ultimos parametros usado para hacer el request.l
     */
    let [oldParamsRequest, setOldParamsRequest] = useState(defaultOldParamsRequest);

    /* END VARS - HOOKS    */


    /*  INIT EVENTS */

    /**
     * Evento que se dispara cuando cambia el valor en el campo en el que se ingresa el término de búsqueda.
     * @param event
     * @return {Promise<void>}
     */
    const onChangeInput = async (event) => {
        const inputValue = await event.target.value;
        setSearchTerms('')
        if (inputValue) {
            setSearchTerms(inputValue.replace(/^\s+/, ''))
        }
    }
    /**
     *
     * @param event
     */
    const onSelectCategory = (event) => {
        const {target: {value},} = event;
        setCategoryCodeSelected(value)
        setCategoryNameSelected(indexedCategories[value])
    }
    /**
     * Evento onChange del slider
     * @param event
     * @param newValue
     */
    const handleChangeSlider = (event, newValue) => {
        setValueSlider(newValue);
    };
    /**
     * Evento que se dispara cuando se selecciona el estado del anuncio.
     * @param event
     */
    const onSelectStatus = (event) => {
        const {target: {value},} = event;
        let selected = statusIndexedAds[value];
        setAdsStatusCodeSelected(value)
        setAdsStatus(selected)
    }
    /**
     *
     * @param event
     */
    const onSelectCta = (event, desc) => {
        const {target: {value},} = event;
        setArrayCta(
            typeof value === 'string' ? value.split(',') : value,
        );
    }

    /**
     * Evento necesario para mostrar el calendario.
     * @param event
     */
    const handleClickCalendar = (event) => {
        setAnchorElCalendar(event.currentTarget);
    };
    /**
     * Evento que escucha cuando se hace clic por fuera del calendario cuando se está mostrando.
     * Este evento cierra el calendario. No es un evento obligatorio.
     */
    const handleCloseCalendar = () => {
        setAnchorElCalendar(null);
    };
    /**
     * Evento que se ejecuta cuando se presiona el botón cancelar en el calendario.
     * Este evento configura el backup del formulario.
     */
    const cancelSetCalendar = () => {
        setAnchorElCalendar(null);
    };

    /**
     * Este evento se ejecuta con el botón aplicar del calendario.
     * Configurar las fechas seleccionas por el usuario.
     * @returns {Promise<void>}
     */
    const setDateRange = async () => {
        setAnchorElCalendar(null);
        setShowLabelCalendar(await dateToFormatUi(startDate) + ' - ' + await dateToFormatUi(endDate))
    };

    /**
     * Evento nativo y obligatorio del Datepicker, se dispara cuando se selecciona la fecha o rango en el calendario.
     * @param dates
     * @returns {Promise<void>}
     */
    const onChangeCalendar = async (dates) => {
        const [start, end] = dates;
        setStartDateIn(start);
        setEndDateIn(end);
    };

    /**
     * Este evento se ejecuta cuando se selecciona alguna fecha en la grilla de opciones de fechas predeterminadas.
     * @param ref
     * @returns {(function(): Promise<void>)|*}
     */
    const onSelectCustomDays = (ref) => async () => {
        setRefSelected(ref)
        if (ref === ref1d) {
            setStartDateIn(getDateLessAnyDays(1))
        }
        if (ref === ref7d) {
            setStartDateIn(getDateLessAnyDays(7))
        }
        if (ref === ref15d) {
            setStartDateIn(getDateLessAnyDays(15))
        }
        if (ref === ref30d) {
            setStartDateIn(getDateLessAnyDays(30))
        }
        if (ref === ref45d) {
            setStartDateIn(getDateLessAnyDays(45))
        }
        if (ref === ref3m) {
            setStartDateIn(getDateLessAnyMonth(3))
        }
        if (ref === ref6m) {
            setStartDateIn(getDateLessAnyMonth(6))
        }
        if (ref === ref12m) {
            setStartDateIn(getDateLessAnyMonth(12))
        }
        if (ref === ref18m) {
            setStartDateIn(getDateLessAnyMonth(18))
        }
        if (ref === ref24m) {
            setStartDateIn(getDateLessAnyMonth(24))
        }
        setEndDateIn(new Date())
    }

    /**
     * Método para restar días a una fecha.
     * @param lessDay Cantidad de días que desea restar a la fecha actual.
     * @returns {Date}
     */
    const getDateLessAnyDays = (lessDay) => {
        let fecha = new Date()
        let result = fecha.setDate(fecha.getDate() - lessDay)
        return new Date(result)
    }
    /**
     * Método para restar meses a la fecha actual.
     * @param lessMonth Cantidad de meses que desea restar a la fecha actual.
     * @returns {Date}
     */
    const getDateLessAnyMonth = (lessMonth) => {
        let fecha = new Date()
        let result = fecha.setMonth(fecha.getDate() - lessMonth)
        return new Date(result)
    }
    /**
     * Es metodo se ejecuta cuando se hace click en el boton
     * de buscar.
     * @returns {Promise<void>}
     */
    const handleSearch = async () => {
        let ctaFilter = []
        for (let descCta of arrayCta) {
            ctaFilter.push(dataComboCtaIndexed[descCta])
        }
        paramsRequest = {}
        paramsRequest = defaultParamsRequest
        paramsRequest.page = 0;
        // termino de busqueda
        if (searchTerms.length > 0) {
            paramsRequest.like = searchTerms
        }
        // Duplicados
        if (valueSlider !== 0) {
            paramsRequest.Duplicated = valueSlider;
        }
        // Configurar el valor que esa en statusAds
        if (adsStatus !== '') {
            paramsRequest.Estatus = adsStatusCodeSelected
        }
        if (ctaFilter.length > 0) {
            paramsRequest.cta = ctaFilter.join(',')
        }
        if (startDate !== null && endDate !== null) {
            paramsRequest.date = [await dateToFormatDateServer(startDate), await dateToFormatDateServer(endDate)].join(',');
        }
        if (categoryCodeSelected !== null) {
            paramsRequest.FK_Category_Code = categoryCodeSelected;
        }
        setQueryStringAndMakeRequest(paramsRequest)
    }

    /**
     * Eliminar o hacer que los filtro vuelvan al valor predeterminado.
     * @returns {Promise<void>}
     */
    const onClickResetFilter = async () => {
        setValueSlider(0);
        setAdsStatus('');
        setArrayCta([]);
        setSearchTerms('');
        setStartDateIn(null)
        setStartDateIn(null)
        setShowLabelCalendar(labelCalendar)
        setCategoryCodeSelected(null)
        // resetear el objecto
        paramsRequest = {}
        paramsRequest.page = 0;
        setQueryStringAndMakeRequest(paramsRequest)
    }

    const setQueryStringAndMakeRequest = (paramsObj) => {
        if (JSON.stringify(paramsObj) !== JSON.stringify(oldParamsRequest)) {
            setOldParamsRequest(JSON.parse(JSON.stringify(paramsObj)))
            setQueryStringObject(paramsObj);
        }
    }

    /*  END EVENTS */


    /* INIT METHODS - FUNCTIONS */

    /**
     * Metodo para cargar la informacion de las categorias del usuario.
     * @returns {Promise<void>}
     */
    const getCategories = async () => {
        try {
            const response = await requestSvc.get(API.LOAD_COMBO + 'user_categories');
            // if (response) {
            if (response.code === 200) {
                
                for (const rowInfo of response.data) {
                    categories.push(rowInfo)
                }
            }
        } catch (error) {
        }
        for (const categoryObject of categories) {
            indexedCategories[categoryObject.FK_Category_Code] = categoryObject.Category_Name
        }
    }
    /**
     *
     * @returns {Promise<boolean>}
     */
    const loadComboCta = async () => {
        let resultLoadCombo = await requestSvc.get(API.LOAD_COMBO + 'cta');
        if (resultLoadCombo.code !== 200) {
            // alert(resultLoadCombo.message)
            return false;
        }
        setDataComboCta(resultLoadCombo.data ?? [])
        for (let rowInfo of resultLoadCombo.data) {
            dataComboCtaIndexed[rowInfo.cta_text_es] = rowInfo.cta_text_en;
        }
    }


    /* END METHODS - FUNCTIONS */

    useEffect(() => {
        getCategories()
        loadComboCta()
        availableStatus.forEach(status => {
            statusIndexedAds[status.code] = status.name;
        })
    }, [])

    return (
        <div className='filters-component-main-layout'>
            <div className={'filters-component-container-options'}>
                {/* Init search input   */}
                <div className='filters-component-wrapper-input'>
                    <input
                        className='filters-component-search-input'
                        value={searchTerms}
                        placeholder='Escribe tu búsqueda'
                        onChange={onChangeInput}/>
                </div>
                {/* End search input    */}
                {/* Init category   */}
                <div className='filters-component-wrapper-option'>
                    <FormControl className={'filters-component-form-control'}>
                        <Select
                            displayEmpty
                            value={categoryNameSelected}
                            variant='outlined'
                            onChange={onSelectCategory}
                            renderValue={
                                (selected) => indexedCategories[categoryCodeSelected] || 'Selecciona categoría'
                            }
                            sx={{height: '100%', '& fieldset': {border: 'none'}}}>
                            {
                                categories.length > 1 && (
                                    categories.map(rowInfo => {
                                        return (
                                            <MenuItem key={rowInfo.FK_Category_Code} value={rowInfo.FK_Category_Code}>
                                                <Radio
                                                    name={rowInfo.FK_Category_Code}
                                                    checked={categoryCodeSelected === rowInfo.FK_Category_Code}/>
                                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                    {rowInfo.Category_Name}
                                                </Box>
                                            </MenuItem>
                                        )
                                    })
                                )
                            }
                        </Select>
                    </FormControl>
                </div>
                {/* End category    */}
                {/* Init slider */}
                <div className={'filters-component-container-specials-options'}>
                    <label>#Ads</label>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '200px',
                        alignItems: 'center'
                    }}>
                        <Slider
                            aria-label='Slider'
                            value={valueSlider}
                            marks={sliderMark}
                            min={0}
                            max={40}
                            title={TOOLTIPS.TOOLBAR_SLIDER}
                            onChange={handleChangeSlider}/>
                        <Typography>&nbsp;&nbsp;&nbsp;{valueSlider === 0 ? 'Off' : valueSlider}</Typography>
                    </div>
                </div>
                {/* End slider  */}
                {/* Init status */}
                <div className='filters-component-wrapper-option'>
                    <FormControl className={'filters-component-form-control'}>
                        <Select
                            displayEmpty
                            value={adsStatus}
                            onChange={onSelectStatus}
                            variant='outlined'
                            renderValue={
                                (selected) => selected || 'Selecciona el estado'
                            }
                            sx={{height: '100%', '& fieldset': {border: 'none'}}}>
                            {
                                availableStatus && (
                                    availableStatus.map(statusInfo => {
                                        return (
                                            <MenuItem key={statusInfo.code} value={statusInfo.code}>
                                                <Radio
                                                    name={statusInfo.name}
                                                    checked={adsStatus === statusInfo.name}/>
                                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                    {statusInfo.name}
                                                </Box>
                                            </MenuItem>
                                        )
                                    })
                                )
                            }
                        </Select>
                    </FormControl>
                </div>
                {/* End status  */}
                {/* Init cta    */}
                <div className='filters-component-wrapper-option'>
                    <FormControl className={'filters-component-form-control'}>
                        <Select
                            displayEmpty
                            multiple
                            value={arrayCta}
                            onChange={onSelectCta}
                            variant='outlined'
                            renderValue={
                                (selected) => selected.join(', ') || 'Selecciona el cta'
                            }
                            sx={{height: '100%', '& fieldset': {border: 'none'}}}>
                            {
                                dataComboCta && (
                                    dataComboCta.map(ctaInfo => {
                                        return (
                                            <MenuItem key={ctaInfo.cta_text_en} value={ctaInfo.cta_text_es}>
                                                <Checkbox
                                                    name={ctaInfo.cta_text_en}
                                                    checked={arrayCta.includes(ctaInfo.cta_text_es)}/>
                                                <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                                    {ctaInfo.cta_text_es}
                                                </Box>
                                            </MenuItem>
                                        )
                                    })
                                )
                            }
                        </Select>
                    </FormControl>
                </div>
                {/* End cta */}
                {/*Calendar*/}
                <div className='filters-component-wrapper-option'>
                    <div className={'filters-component-wrapper-option-calendar'}>
                        <div className={'filters-component-wrapper-input-calendar'}
                             onClick={handleClickCalendar}>
                            <input className={'filters-component-input-calendar'} readOnly={true}
                                   value={showLabelCalendar}/>
                        </div>
                        <Menu sx={{paddingTop: '0'}}
                              id='fade-menu'
                              MenuListProps={{
                                  'aria-labelledby': 'fade-button',
                              }}
                              anchorEl={anchorElCalendar}
                              open={openCalendar}
                              onClose={handleCloseCalendar}
                              TransitionComponent={Fade}>
                            <DatePicker
                                locale={'es'}
                                selected={startDate}
                                onChange={onChangeCalendar}
                                startDate={startDate}
                                endDate={endDate}
                                maxDate={enableDateRange}
                                selectsRange
                                inline
                            />
                            <Divider sx={{mt: 1}}/>
                            <div style={{margin: 8}}>
                                <Typography>Últimos</Typography>
                            </div>
                            {/* Grilla de fechas predeterminadas    */}
                            <div className={'filters-component-calendar-container-custom-values'}>
                                <div className={'filters-component-calendar-row-custom-values'}>
                                    <div className={refSelected === ref1d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref1d)}>
                                        {'1d'}
                                    </div>
                                    <div className={refSelected === ref7d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref7d)}>
                                        {'7d'}
                                    </div>
                                    <div ref={ref15d} className={refSelected === ref15d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref15d)}>
                                        {'15d'}
                                    </div>
                                    <div ref={ref30d} className={refSelected === ref30d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref30d)}>
                                        {'30d'}
                                    </div>
                                    <div ref={ref45d} className={refSelected === ref45d ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref45d)}>
                                        {'45d'}
                                    </div>
                                </div>
                                <div className={'filters-component-calendar-row-custom-values'}>
                                    <div ref={ref3m} className={refSelected === ref3m ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref3m)}>
                                        {'3m'}
                                    </div>
                                    <div ref={ref6m} className={refSelected === ref6m ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref6m)}>
                                        {'6m'}
                                    </div>
                                    <div ref={ref12m} className={refSelected === ref12m ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref12m)}>
                                        {'12m'}
                                    </div>
                                    <div ref={ref18m} className={refSelected === ref18m ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref18m)}>
                                        {'18m'}
                                    </div>
                                    <div ref={ref24m} className={refSelected === ref24m ? selected : unSelected}
                                         onClick={onSelectCustomDays(ref24m)}>
                                        {'24m'}
                                    </div>
                                </div>
                            </div>

                            <div className={'filters-component-wrapper-button'}>
                                <button className={'filters-component-button-outline-border'}
                                        onClick={cancelSetCalendar}>Cancelar
                                </button>
                                <button className={'filters-component-button-regular'}
                                        disabled={startDate === null || endDate === null}
                                        onClick={setDateRange}>Aplicar
                                </button>
                            </div>

                        </Menu>
                    </div>
                </div>
                {/*Fin calendar*/}
                {/* Init buttons */}
                <div className={'filters-component-container-buttons'}>
                    <Button
                        disabled={isLoadingData}
                        variant='contained'
                        className='submitBtn'
                        color='primary'
                        onClick={handleSearch}>
                        Buscar
                    </Button>
                    {
                        !isLoadingData && <BackspaceIcon
                            sx={{fontSize: '24px', marginLeft: '8px'}}
                            onClick={onClickResetFilter}/>
                    }
                </div>
                {/* End buttons */}
            </div>
            {/* Init label category selected */}
            <div className={'filters-component-container-buttons'}>
                <p style={{
                    fontWeight: 'bold',
                    fontSize: '14px'
                }}>Categoria:&ensp;<span
                    style={{
                        fontSize: '18px',
                        fontWeight: 'bold',
                        fontStyle: 'oblique',
                        color: 'black'
                    }}>{indexedCategories[categoryCodeSelected ?? categoryCodeSelected]}</span>
                </p>
            </div>
            {/* End label category seleted  */}
        </div>
    );
}
